/**
 * Hard-coded feature flags shared by the API and the web app (one source of truth).
 * Ultra-Snip currently serves private members only, so optional friction is switched off.
 *
 * - `email`: outgoing email (password reset links, notifications, security alerts). No email
 *   provider is configured yet, so everything that depends on it is off and hidden.
 * - `emailVerification`: require a confirmed email before sign-in. Needs `email`.
 * - `twoFactor`: offer TOTP two-factor setup and sign-in challenges.
 * - `stepUpAuth`: re-ask for password / 2FA code before sensitive actions (withdrawals, key export).
 * - `deviceSessions`: list signed-in devices in settings and let the user sign them out.
 */
export const Features = {
    email: false,
    emailVerification: false,
    twoFactor: false,
    stepUpAuth: false,
    deviceSessions: false,
};
//# sourceMappingURL=features.js.map